import { FC } from "react";

interface Props {
  checked: boolean;
}

const Radio: FC<Props> = ({ checked }): JSX.Element => {
  return (
    <div className="relative rounded-full border border-primary bg-white w-16 h-16">
      {checked && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full bg-yellow-500 w-8 h-8" />
      )}
    </div>
  );
};
export default Radio;
